<div class="dropdown container-fluid">
  <form [formGroup]="filterForm">
    <div class="d-flex flex-row flex-nowrap align-items-end w-100">
      @for(item of filters; track $index){
      <div [ngClass]="item?.colClass || (item?.type === 'multiselect-toggle' ? 'col' : 'col-auto')">
        @switch (item?.type) {
        @case ('multiselect-toggle') {
        <multiselect-toggle [data]="item" [optionsMap]="options"></multiselect-toggle>
        }
        @case ('dropdown') {
        <app-global-dropdown [formControlName]="item.key" [options]="options[item.key] || []" [data]="item">
        </app-global-dropdown>
        }
        @case ('slider-range') {
        <app-mat-slider [data]="item">
        </app-mat-slider>
        }
        @case ('button') {
          @if (!hideInternalButtons) {
            <app-button [data]="item" [selectedKey]="selectedKey"
              [showResetButton]="showResetButton && hasInsightsButton && item?.key === 'insights'"
              (selectionChange)="onButtonSelectionChange($event)" (resetClick)="resetButton()">
            </app-button>
          }
        }
        @case ('icon') {
        <mat-icon (click)="download(item.apiUrl)" style="cursor:pointer;margin-top: 2.2rem;">download</mat-icon>
        }
        @case ('search') {
        <app-search-container [data]="item" (search)="onSearch($event, item.key)">
        </app-search-container>
        }

        @default {}
        }
      </div>
      }

      <div class="d-flex align-items-center" *ngIf="showResetButton && !hasInsightsButton && !hideInternalButtons">
        <div (click)="resetButton()" class="reset d-flex align-items-center" style="cursor: pointer;">
          <mat-icon class="material-symbols-outlined" style="color: #118DFF; font-family: 'Material Symbols Outlined' !important;">filter_alt_off</mat-icon>
          <span class="reset-label ms-1" style="color: #118DFF; font-weight: 600; font-size: 13px;">Reset</span>
        </div>
      </div>
    </div>
  </form>
</div>